var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneNumber(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500.133-1309.6H-1291.47v2421.33H500.133V-1309.6z",
    stroke: "#2ED06E",
    strokeWidth: 3.67,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.533 54.4H9.6v1.067h36.933V54.4z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6.933h24.532A2.267 2.267 0 0142.266 3.2v49.333a2.133 2.133 0 01-2.134 2.134H15.866a2.133 2.133 0 01-2.134-2.134v-49.6a2 2 0 011.867-2z",
    fill: "#77D9F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.067 19.6a2.667 2.667 0 100-5.333 2.667 2.667 0 000 5.333zM28 19.6a2.667 2.667 0 100-5.333 2.667 2.667 0 000 5.333zM34.934 19.6a2.667 2.667 0 100-5.333 2.667 2.667 0 000 5.333zM21.067 26.534a2.667 2.667 0 100-5.334 2.667 2.667 0 000 5.334zM28 26.534a2.667 2.667 0 100-5.334 2.667 2.667 0 000 5.334zM34.934 26.534a2.667 2.667 0 100-5.334 2.667 2.667 0 000 5.334zM21.067 33.334a2.667 2.667 0 100-5.334 2.667 2.667 0 000 5.334zM28 33.334A2.667 2.667 0 1028 28a2.667 2.667 0 000 5.334zM34.934 33.334a2.667 2.667 0 100-5.334 2.667 2.667 0 000 5.334zM21.067 40.134a2.667 2.667 0 100-5.334 2.667 2.667 0 000 5.334zM28 40.134a2.667 2.667 0 100-5.334 2.667 2.667 0 000 5.334zM34.934 40.134a2.667 2.667 0 100-5.334 2.667 2.667 0 000 5.334z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 47.067a2.667 2.667 0 100-5.334 2.667 2.667 0 000 5.334z",
    fill: "#485CC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M41.732 52.267v-49.2A2.267 2.267 0 0040 .8h-2.667L14.8 54.533h24.666a2.267 2.267 0 002.267-2.266z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6 1.467A2.133 2.133 0 0141.733 3.6v48.267a2.267 2.267 0 01-2.133 2.266H16.4a2.266 2.266 0 01-2.133-2.266v-48.4a2 2 0 011.866-2H39.6zm-26.267 50.4a3.064 3.064 0 001.862 2.954c.38.163.79.246 1.205.246h23.2a3.066 3.066 0 003.067-3.2V3.6A3.067 3.067 0 0039.6.533H16.133a2.8 2.8 0 00-2.8 2.934",
    fill: "#37517E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.732 1.2h12.534v1.067A1.467 1.467 0 0132.932 3.6h-9.866a1.467 1.467 0 01-1.334-1.333V1.2z",
    fill: "#37517E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 9.56,
    y1: 54.92,
    x2: 46.44,
    y2: 54.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h56v56H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneNumber);
export default __webpack_public_path__ + "static/media/phone_number.e48a976e04f212aa01641640b5ab097c.svg";
export { ForwardRef as ReactComponent };